import { useSortable } from "@dnd-kit/sortable"
import { CSS } from "@dnd-kit/utilities"
import ActivitiesWeeklyCard, { type ActivitiesWeeklyCardProps } from "./activities-weekly-card"
import isDraggableStatus from "@/modules/study/utils/is-draggable-status"
import { getDraggableDay } from "@/modules/study/utils/time"
import type { Activities as Column } from "../../../entities/activities"
import { isSameDay } from "date-fns"

interface ActivitiesWeeklyCardSortableProps {
  activity: ActivitiesWeeklyCardProps
  areDragging: boolean
  isPending: boolean
  columnDate: string
  sourceColumn: Column | null
}

export default function ActivitiesWeeklyCardSortable({
  activity,
  areDragging,
  isPending,
  columnDate,
  sourceColumn,
}: ActivitiesWeeklyCardSortableProps) {
  const isDraggableDay = getDraggableDay(activity.dateTime)

  const isDraggable = isDraggableStatus(activity.status)

  // The activity is draggable only if it is scheduled for today or a future date,
  // and its status is "pending", "rescheduled", or "failed".
  // Approved activities, skipped activities, and past activities (even if pending) are not draggable.
  const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({
    id: activity.id,
    disabled: !isDraggableDay || !isDraggable,
  })

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.5 : 1,
  }

  const isFromAnotherColumn = Boolean(
    sourceColumn && !isSameDay(new Date(columnDate), new Date(sourceColumn.date)),
  )

  return (
    <div ref={setNodeRef} style={style}>
      <ActivitiesWeeklyCard
        {...activity}
        dragAttributes={attributes}
        dragListeners={listeners}
        isPending={isPending}
        canHideCard={areDragging && isFromAnotherColumn}
      />
    </div>
  )
}
